import { selectBookActionTypes } from './Constants';

const initialState = {
	loading: true,
	selectBookData: {},
	setBookLoading: false,
	loadingSubjectDetails: false,
	subjectDetails: {},
	isSelectBookModalOpen: false,
	appliedFilters: {},
	submitLoading: false,
	selectBookModal: {
		loading: false,
		open: false,
	},
	selectBookModalInfo: {
		educationType: null,
		level: null,
		grade: null,
	},
	educationTypes: [],
	levels: [],
	grades: [],
	userData: {},
	educationTypesLoading: true,
	previousLocation: null,
};

export default function selectBookReducer(state = initialState, action) {
	const { type, payload } = action;
	const {
		selectBookData,
		isSelectBookModalOpen,
		data,
		offset,
		educationTypes,
		userData,
		options,
		selectBookModalInfo,
		location,
	} = payload || {};

	switch (type) {
		case selectBookActionTypes.GET_SUBJECT_DETAILS_OF_USER:
			return {
				...state,
				loadingSubjectDetails: true,
			};
		case selectBookActionTypes.GET_SUBJECT_DETAILS_OF_USER_SUCCESS:
			return {
				...state,
				subjectDetails: data,
				loadingSubjectDetails: false,
			};
		case selectBookActionTypes.GET_SUBJECT_DETAILS_OF_USER_ERROR:
			return {
				...state,
				loadingSubjectDetails: false,
			};
		case selectBookActionTypes.GET_SELECT_BOOK:
			return {
				...state,
				loading: !offset,
			};
		case selectBookActionTypes.GET_SELECT_BOOK_SUCCESS:
			return {
				...state,
				selectBookData,
				loading: false,
			};
		case selectBookActionTypes.GET_SELECT_BOOK_ERROR:
			return {
				...state,
				loading: false,
			};
		case selectBookActionTypes.CHANGE_SELECT_BOOK_FILTERS:
			return {
				...state,
				...data,
			};
		case selectBookActionTypes.ADD_SELECTION:
			return {
				...state,
				submitLoading: true,
			};
		case selectBookActionTypes.ADD_SELECTION_ERROR:
			return {
				...state,
				submitLoading: false,
			};
		case selectBookActionTypes.TOGGLE_SELECT_BOOK_MODAL:
			return {
				...state,
				selectBookModal: {
					loading: false,
					open: isSelectBookModalOpen,
				},
			};
		case selectBookActionTypes.SET_SBM_INFO:
			return {
				...state,
				...options,
				selectBookModalInfo,
			};
		case selectBookActionTypes.SBM_GET_EDUCATION_TYPES:
			return {
				...state,
				educationTypesLoading: true,
			};
		case selectBookActionTypes.SBM_GET_EDUCATION_TYPES_SUCCESS:
			const { educationType, level } = state.selectBookModalInfo;
			const levels =
				(educationType &&
					educationType.id &&
					educationTypes.education_types.filter((item) => item.id === educationType.id)[0]
						.options) ||
				[];
			const grades =
				(levels &&
					level &&
					level.school_track_id &&
					!!levels.length &&
					levels.filter((item) => item.school_track_id === level.school_track_id)[0]
						.options) ||
				[];
			return {
				...state,
				educationTypes: educationTypes.education_types,
				levels,
				grades,
				educationTypesLoading: false,
			};
		case selectBookActionTypes.SBM_GET_EDUCATION_TYPES_ERROR:
			return {
				...state,
				loading: false,
				educationTypesLoading: false,
			};
		case selectBookActionTypes.SBM_GET_USER_DETAILS_SUCCESS:
			return {
				...state,
				userData,
			};
		case selectBookActionTypes.SET_CANDIDATE_BOOK:
			return {
				...state,
				setBookLoading: true,
			};
		case selectBookActionTypes.SET_CANDIDATE_BOOK_SUCCESS:
		case selectBookActionTypes.SET_CANDIDATE_BOOK_ERROR:
			return {
				...state,
				setBookLoading: false,
			};
		case selectBookActionTypes.SET_LOCATION:
			return {
				...state,
				previousLocation: location,
			};
		case selectBookActionTypes.CLEAN_SELECT_BOOK_STATE:
			return {
				...initialState,
				previousLocation: state.previousLocation,
			};

		default:
			return state;
	}
}
